'use strict';
require('./loading.scss');

const React = require('react/addons'),
    PropTypes = React.PropTypes;

const Loading = React.createClass({displayName: "Loading",

    propTypes: {
        size: PropTypes.number
    },

    render() {
        return (
            React.createElement("div", {className: "bp-loading text-center", 
                 style:  {paddingTop: '50px', margin: '0 auto'} }, 
                React.createElement("i", {className: "bp-loading__icon"})
            )
        );
    }
});

module.exports = Loading;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Loading/Loading.js
 **/